import { AccessTime, Schedule } from '@mui/icons-material';
import { Box } from '@mui/material';
import React from 'react';

import { OverdueAndDueDatesResponse } from '../../../../../../../lib/api/fundsDashboard/fundsDashboard';
import StatCard from '../../../../../../../lib/designSystem/Charts/StatCard';

interface OverdueSummaryProps {
  data: OverdueAndDueDatesResponse;
}

const OverdueSummary: React.FC<OverdueSummaryProps> = ({ data }) => {
  return (
    <Box
      sx={{ display: 'flex', flexDirection: 'column', gap: 2, height: '100%' }}
    >
      <StatCard
        label="Vencimientos Próximos"
        value={data.totalDueSoon || 0}
        valueLabel="reventas"
        color="#ed6c02"
        icon={<Schedule sx={{ fontSize: 24 }} />}
      />
      <StatCard
        label="Días Promedio de Mora"
        value={data.averageOverdueDays || 0}
        valueLabel="días"
        color="#9c27b0"
        icon={<AccessTime sx={{ fontSize: 24 }} />}
      />
    </Box>
  );
};

export default OverdueSummary;
